export default __webpack_public_path__ + "static/media/sever.72fca1d8.png";